export default __webpack_public_path__ + "static/media/trippin4.fb3477bd.jpg";